<ng-container *ngIf="!isSkeleton else skeleton">
  <div [ngClass]="{'bz-product-wrapper-border-shadow': !isNameInInfoDetails}" class="bz-product-wrapper"
    [ngStyle]="{'height': isOrder ? '170px': ''}">
    <a *ngIf="!isNameInInfoDetails || isCart" (click)="clearContainer()" [class.cart-product-mobile-name]="isCart" class="bz-product-title"
      [routerLink]="BzProduct | infoDrugRouterLink" [textContent]="BzProduct?.name"></a>

    <div class="bz-product-info">

      <div class="bz-product-img">

        <a *ngIf="!isPharmacyPopUp" [routerLink]="BzProduct | infoDrugRouterLink"
          (click)="clearContainer()">
          <picture class="bz-image-product">
            <source [srcset]="(imgPath + '160-120/' + BzProduct.img + '.webp') | isImgNull" type="image/webp">
            <img
              bz-image
              [ngStyle]="{'filter': !BzProduct?.foundInPharm && !BzProduct?.otherTowns && isSearchPage ? 'grayscale(1)' : '', 'cursor' : 'pointer'}"
              [src]="(imgPath + '160-120/' + 'png/' + BzProduct.img + '.png') | isImgNull"
              [alt]="localize.getLang() === 'ua' ? 'Ціни на ' + BzProduct?.name : 'Цены на ' + BzProduct?.name"
              [title]="localize.getLang() === 'ua' ? 'Дізнатися ціни та забронювати ' + BzProduct?.name : 'Узнать цены и забронировать ' + BzProduct?.name">
          </picture>
        </a>

        <picture class="bz-image-product" *ngIf="isPharmacyPopUp"
          (click)="redirectToProductInfo(BzProduct.id, BzProduct.url, isPharmacyPopUp ? true : false)">
          <source [srcset]="(imgPath + '160-120/' + BzProduct.img + '.webp') | isImgNull" type="image/webp">
          <img bz-image [src]="(imgPath + '160-120/' + 'png/' + BzProduct.img + '.png') | isImgNull" [alt]="BzProduct?.name"
            [ngStyle]="{'filter': !BzProduct?.foundInPharm && !BzProduct?.otherTowns && isSearchPage ? 'grayscale(1)' : '', 'cursor' : 'pointer'}">
        </picture>

        <ng-container [ngSwitch]="locationORprice">
          <ng-template *ngSwitchCase="_typeProduct.price">
            <span class="bz-product-price" [textContent]="BzProduct?.price"></span>
          </ng-template>
          <ng-template transloco let-t *ngSwitchCase="_typeProduct.location">
            <span *ngIf="BzProduct?.foundInPharm" [ngStyle]="{'color': colors.primary}"
              [ngClass]="{'finded' : BzProduct?.foundInPharm}" class="bz-product-location">
              {{t('in-pharmcy-count1', { count: BzProduct?.count})}}
              <br class="breaker" />
              {{t('in-pharmcy-count2')}}
            </span>
            <span *ngIf="!BzProduct?.foundInPharm" class="bz-product-location not-found">
              <span>{{'notFindedIn' | transloco}} <br /> {{'shortCity' | transloco}}
                {{(currentCity | async)}}
              </span>
            </span>
          </ng-template>
        </ng-container>
      </div>

      <div class="bz-product-details">
        <span class="popup-without-link"
          (click)="redirectToProductInfo(BzProduct.id, BzProduct.url, !!isPharmacyPopUp)">

          <a (click)="clearContainer()" [routerLink]="BzProduct | infoDrugRouterLink"
            [ngStyle]="{'pointer-events': isPharmacyPopUp ? 'none' : ''}">

            <ul [ngStyle]="{'margin-top' : !isCart && !isList && !isOrder ? '15px' : '0px'}">
              <ng-container *ngIf="isNameInInfoDetails">
                <li *ngIf="BzProduct?.name" [class.product-name-mobile]="isCart" #title class="bz-product-details-name"
                  [ngStyle]="{'width' : isCart ? '340px' : '150px', 'white-space': isCart ? 'unset' : ''}"
                  [textContent]="BzProduct?.name"></li>
              </ng-container>
              <li [ngStyle]="{'width' : isCart ? '340px' : ''}" class="bz-product-details-manufac"
                [textContent]="BzProduct?.manufac"></li>
              <ng-container *ngIf="isNameInInfoPrices">
                <div class="bz-product-details-price-wrapper" *ngIf="BzProduct?.price">
                  <li class="bz-product-details-price"
                    [ngStyle]="{'display': isOrder ? 'none' : 'block'}"
                    [textContent]="isPharmaciesPage ? (BzProduct?.price | moneyFormat) : (BzProduct?.price | moneyFormat)">
                  </li>
                  <div *ngIf="isCart" (click)="deleteProductFromCart($event)" class="delete-product-button" [innerHTML]="'deleteProduct' | transloco"></div>
                </div>
                <li *ngIf="isOrder" class="bz-product-details-price"
                  [ngStyle]="{'color' : BzProduct.errorKey?.type === '1' || BzProduct.errorKey?.type === '3' ? colors.second : ''}"
                  [textContent]="((BzProduct?.price) | moneyFormat)"></li>
                <span *ngIf="BzProduct.errorKey?.type === '1' || BzProduct.errorKey?.type === '3'"
                  class="price-error">({{'oldPrice' | transloco}}:
                  {{BzProduct?.errorKey.oldPrice | moneyFormat}}<span *ngIf="BzProduct.errorKey?.type === '3'"> <br
                      class="mobile-br"> /
                    {{BzProduct?.errorKey.oldPriceSingle | moneyFormat}} уп.</span>)
                </span>
                <div class="bz-product-details-price-wrapper">
                  <li class="bz-product-details-price" [textContent]="BzProduct?.priceRange ? (BzProduct?.priceRange | moneyFormat) : ''"></li>
                  <div *ngIf="isList" (click)="deleteProductFromList($event)" class="delete-product-button" [innerHTML]="'deleteProduct' | transloco"></div>
                </div>
              </ng-container>

              <ng-container *ngIf="isOrder">
                <p class="isOrderPrivate" style="padding: 3px 0; width: 350px;">
                  <ng-container *ngIf="(BzProduct?.orderedContentNum) > 0">
                    {{'packaging' | transloco}}:
                    <span
                      [ngStyle]="{'color': BzProduct.errorKey?.type === '3' || BzProduct.errorKey?.type === '2' ? '#ef5086' : '#449bd1' }"
                      style="font-weight: 600;">
                      {{BzProduct?.orderedContentNum | mathfloor}} шт.
                    </span>
                  </ng-container>
                  <span *ngIf="BzProduct.errorKey?.type === '2' || BzProduct.errorKey?.type === '3'">
                    <span *ngIf="BzProduct?.errorKey?.oldQty % 1 !== 0"> <br class="mobile-br"> ({{'oldQty' |
                      transloco}}:
                      {{BzProduct?.errorKey.oldQty | mathfloor}} шт.)</span>
                    <span *ngIf="BzProduct?.errorKey?.oldQty % 1 == 0"> <br class="mobile-br">
                      ({{'oldQty' | transloco}}:
                      {{BzProduct?.errorKey.oldQty}} шт.)</span>
                  </span>
                </p>

                <p class="isOrderPrivate" style="width: 350px;" *ngIf="BzProduct?.packageContentNum > 1">
                  <span>
                    {{BzProduct?.packageContentType}}:
                    <span
                      [ngStyle]="{'color': BzProduct.errorKey?.type === '3' || BzProduct.errorKey?.type === '2' ? '#ef5086' : '#449bd1' }"
                      style="font-weight: 600;">
                      {{ ((BzProduct?.orderedContentNum % 1) * BzProduct?.packageContentNum) | number: '1.0-0' }} шт.
                    </span>
                    <br class="mobile-br">
                    <span *ngIf="BzProduct.errorKey?.type === '2' || BzProduct.errorKey?.type === '3'">
                      ({{'oldQty' | transloco}}: {{ ((BzProduct?.errorKey.oldQty % 1) * BzProduct?.packageContentNum) |
                      number: '1.0-0' }} шт.)
                    </span>
                  </span>
                </p>
              </ng-container>

              <ng-container *ngIf="isPharmaciesPage">
                <p class="isOrderPrivate" style="padding: 3px 0; width: auto;">
                  <ng-container *ngIf="(BzProduct?.qty | mathfloor) > 0">
                    <span>{{'packaging' | transloco}}: </span>
                    <span
                      [style]="'font-weight: bold; color: ' + (BzProduct?.isQuantityEnough ? colors.primary : colors.second)">{{BzProduct?.qty
                      | mathfloor}} шт.</span>
                  </ng-container>
                </p>
                <p class="isOrderPrivate" style="width: auto;">
                  <ng-container *ngIf="(BzProduct?.qty % 1 > 0)">
                    <span *ngIf="((BzProduct?.qty % 1 | number : '1.2-2') * BzProduct?.packageContentNum) > 0">
                      {{BzProduct?.packageContentType}}:
                      <span
                        [style]="'font-weight: bold; color:' + (BzProduct?.isQuantityEnough ? colors.primary : colors.second)">
                        {{ ((BzProduct?.qty % 1 | number : '1.2-2') * BzProduct?.packageContentNum) | mathround}}
                        шт.</span>
                    </span>
                  </ng-container>
                </p>
              </ng-container>

            </ul>

          </a>
        </span>

        <div class="list-inputs-wrapper" *ngIf="isListCounts">
          <bz-count-packaging [qty]="BzProduct?.packageNum" [type]="'parent'" [namePack]="'packaging'"
            (onDecrementCount)="decrementCountPackagesInList($event)"
            (onIncrementCount)="incrementCountPackagesInList($event)"></bz-count-packaging>

          <bz-count-packaging *ngIf="BzProduct?.packageContentNum > 1" [qty]="BzProduct?.blisterNum" [type]="'child'"
            [namePack]="BzProduct?.packageContentType" (onDecrementCount)="decrementCountBlistersInList($event)"
            (onIncrementCount)="incrementCountBlistersInList($event)"></bz-count-packaging>

        </div>

        <div class="list-inputs-wrapper" *ngIf="isCart">

          <ng-container *ngIf="showPopUpQty">
            <span (click)="close()" [ngClass]="{'move-left': moveBlock, 'move-top': moveTop}" class="popup-max-qty"
              id="popup-qty">
              <span *ngIf="BzProduct?.balanceNum % 1 == 0">{{'remainderOfQty' | transloco}}
                {{ BzProduct.balanceNum | declension }}</span>
              <span *ngIf="BzProduct?.balanceNum % 1 !== 0">{{'remainderOfQty' | transloco}}
                {{ BzProduct.balanceNum | mathfloor | declension }}
                {{'and' | transloco}}
                {{ (( (BzProduct.balanceNum % 1) * BzProduct.packageContentNum) | number: '1.0-0') }}
                {{ ((BzProduct.packageContentType | lowercase) | declensionString: (( (BzProduct.balanceNum % 1) *
                BzProduct.packageContentNum) | number: '1.0-0') ) }}
              </span>
              <span class="triangle"></span>
            </span>
          </ng-container>

          <bz-count-packaging [qty]="BzProduct?.packageNum" [type]="'parent'" [namePack]="'packaging'" [isCart]="true"
            (onDecrementCount)="decrementCountPackagesInCart($event)"
            (onIncrementCount)="incrementCountPackagesInCart($event);"></bz-count-packaging>

          <bz-count-packaging *ngIf="BzProduct?.packageContentNum > 1 && apteka.isPartialSale"
            [qty]="BzProduct?.blisterNum" [type]="'child'" [namePack]="BzProduct?.packageContentType" [isCart]="true"
            (onDecrementCount)="decrementCountBlistersInCart($event)"
            (onIncrementCount)="incrementCountBlistersInCart($event);"></bz-count-packaging>

        </div>

      </div>

    </div>

    <div *ngIf="reviewsORcounts === _typeProduct.reviews" class="bz-product-footer">

      <ng-container *ngIf="reviewsORcounts === _typeProduct.reviews">
        <div class="bz-product-footer-left">
        </div>
        <div class="bz-product-footer-right"
          [ngClass]="{'move-left-btns': !BzProduct?.foundInPharm && !BzProduct?.otherTowns && !isHomePage && !isCatalogPage}">
          <bz-button *ngIf="BzProduct?.foundInPharm || BzProduct?.otherTowns" class="list" (click)="addProductTolist()"
            [type]="'transparent'" [k]="1.45"
            [text]="BzProduct?.inList ? ('already-in-list' | transloco) : ('in-list' | transloco)"
            [textColor]="BzProduct?.inList ? colors.second : '#292929bf'" [icon]="'list.svg'"
            [defaultIconColor]="BzProduct?.inList ? colors.second : '#292929bf'" [content]="'all'" [isProduct]="true"
            [size]="{w: 60, h: 45}" [radius]="false">
          </bz-button>

          <bz-button class="favorite" (click)="addProductToFavorite()" [type]="'transparent'" [k]="1.45"
            [text]="BzProduct?.isFavorite ? ('already-in-favorite' | transloco) : ('in-favorite' | transloco)"
            [textColor]="BzProduct?.isFavorite ? colors.second : '#292929bf'"
            [icon]="BzProduct?.isFavorite ? 'sm-heart-inner.svg' : 'sm-heart.svg'"
            [defaultIconColor]="BzProduct?.isFavorite ? colors.second : '#292929bf'" [content]="'all'"
            [isProduct]="true" [size]="{w: 60, h: 45}" [radius]="false">
          </bz-button>
        </div>
      </ng-container>
    </div>


    <div *ngIf="isCart" [ngClass]="{'btnDelPosition': isCart}" class="btnDelOrder" (click)="deleteProductFromCart()"
      innerHTML="{{'deleteProduct' | transloco}}"></div>

    <div *ngIf="isList" class="btnDelOrder" (click)="deleteProductFromList()">
      <p class="deleteIconTextMobile">{{'delete' | transloco}}</p>
    </div>

    <div *ngIf="!isCart"
      [ngStyle]="{'margin-top': isNameInInfoDetails ? '0' : '-50px', 'display': isOrder ? 'none' : ''}"
      class="bz-product-btn-to-pharmacy">
      <ng-container *ngIf="isBtnToPharmacy else toOrder">
        <a *ngIf="BzProduct?.foundInPharm && !BzProduct?.otherTowns"
          [routerLink]="getRouterLinkToPharmcies() + '/' + BzProduct.url + '/' + (townForNavigateUrl ? townForNavigateUrl : locationService.townEn)">
          <bz-button class="to-pharmcy"
            [type]="colors.primary" [k]="1.35" [text]="'select-pharma' | transloco" [textColor]="'#FFFFFF'" [icon]="''"
            [defaultIconColor]="'#FFFFFF'" [content]="'text'" [size]="{w: 65, h: 70}"
            [radius]="['100%','0%','0%','100%']" navigateEmitter></bz-button>
        </a>

        <bz-button *ngIf="!BzProduct?.foundInPharm && BzProduct?.otherTowns" (click)="toOtherPharmacies()" class="to-pharmcy other-cities"
            [type]="colors.none" [k]="1.35" [text]="'prices-in-other-cities' | transloco" [textColor]="'#000000'"
            [icon]="''" [borderColor]="'#449bd1'" [defaultIconColor]="'#FFFFFF'" [content]="'text'"
            [size]="{w: 65, h: 70}" [radius]="['100%','0%','0%','100%']" othersClickCatcher [fromCard]="true" navigateEmitter>
        </bz-button>

        <bz-button *ngIf="!BzProduct?.foundInPharm && !BzProduct?.otherTowns" class="to-pharmcy disabled"
            [type]="'#a3a3a3'" [k]="1.35" [text]="'productNotFound' | transloco" [textColor]="'#FFFFFF'" [icon]="''"
            [defaultIconColor]="'#FFFFFF'" [content]="'text'" [size]="{w: 65, h: 70}"
            [radius]="['100%','0%','0%','100%']">
        </bz-button>

      </ng-container>
      <ng-template #toOrder>
        <bz-button
          [ngStyle]="{'display': isPharmaciesPage && apteka.products.length > 1 ? 'block' : 'none'}"
          (click)="addProductToCart(); onToOrder($event, BzProduct?.id)"
          [type]="BzProduct.isOrder ? colors.none : colors.primary"
          [setTextColorForInnerSpan]="true"
          [k]="1.45"
          [text]="(BzProduct.isOrder ? 'cancel' : 'toOrder') | transloco"
          [textColor]="BzProduct.isOrder ? '#449bd1' : '#FFFFFF'"
          [borderColor]="BzProduct.isOrder ? '#449bd1' : ''"
          [size]="{w: 55, h: 45}"
          [radius]="['40%','0%','0%','40%']">
        </bz-button>
      </ng-template>
    </div>


    <ng-container *ngIf="isBtnToMenu">
      <div id="btnDDM" (click)="openMenuPreparat(BzProduct, BzProduct?.menu)" class="bz-product-btn-to-menu" [ngStyle]="{
                    'mask': 'url(../../../assets/more.svg) no-repeat center',
                    '-webkit-mask': 'url(../../../assets/more.svg) no-repeat center',
                    '-webkit-mask-size': 'contain',
                    'mask-size': 'contain'
                }"></div>
    </ng-container>

    <ng-template #dropdownMenu></ng-template>

  </div>
</ng-container>

<ng-template #skeleton>

  <div [ngClass]="{'bz-product-wrapper-border-shadow': !isNameInInfoDetails}" class="bz-product-wrapper"
    [ngStyle]="{'height': isOrder ? '170px': ''}">
    <span *ngIf="!isNameInInfoDetails" class="bz-product-title">
      <ngx-skeleton-loader [theme]="{ height: '14px',width: '173px', 'margin-bottom': 0}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ height: '14px',width: '90px', 'margin-bottom': 0}"></ngx-skeleton-loader>
    </span>

    <div class="bz-product-info" [ngStyle]="{'cursor' : isOrder ? 'auto' : 'pointer'}">

      <div class="bz-product-img" [ngStyle]="{'cursor' : isOrder ? 'pointer' : 'inherit'}">
        <ngx-skeleton-loader [theme]="{ height: '100px',width: '173px', 'margin-bottom': 0}"></ngx-skeleton-loader>
      </div>

      <div class="bz-product-details">
        <ul [ngStyle]="{'margin-top' : !isCart && !isList && !isOrder ? '15px' : '0px'}">
          <ng-container *ngIf="isNameInInfoDetails">
            <li *ngIf="BzProduct?.name" class="bz-product-details-name"
              [ngStyle]="{'width' : isCart ? '340px' : '150px', 'white-space': isCart ? 'unset' : ''}"></li>
          </ng-container>
          <li [ngStyle]="{'width' : isCart ? '340px' : ''}" class="bz-product-details-manufac">
            <ngx-skeleton-loader [theme]="{ height: '14px',width: '120px', 'margin-bottom': 0, 'margin-left': '5px'}">
            </ngx-skeleton-loader>
          </li>
          <ng-container *ngIf="isNameInInfoPrices">
            <li class="bz-product-details-price" [ngStyle]="{'display': isOrder ? 'none' : 'block'}">
              <ngx-skeleton-loader
                [theme]="{ height: '14px',width: '40px', 'margin-bottom': '-3px', 'margin-left': '5px'}">
              </ngx-skeleton-loader>
              <span
                style="display: inline-flex; align-items: center; justify-content: center">&nbsp;&ndash;&nbsp;</span>
              <ngx-skeleton-loader [theme]="{ height: '14px',width: '40px', 'margin-bottom': '-3px'}">
              </ngx-skeleton-loader>
            </li>
            <li *ngIf="isOrder" class="bz-product-details-price"></li>
            <span class="price-error"></span>
            <li class="bz-product-details-price"></li>
          </ng-container>

          <ng-container *ngIf="isOrder">
            <p class="isOrderPrivate" style="padding: 3px 0; width: 350px;">
              <ng-container>
                {{'packaging' | transloco}}:
                <span [style]="'font-weight: bold; color: ' + colors.primary">

                </span>
              </ng-container>
              <span style="color: #292929bf">
                <span> шт.</span>
                <span> шт.</span>
              </span>
            </p>
            <p class="isOrderPrivate" style="width: 350px;">
              <span>
                <span [style]="'font-weight: bold; color:' + colors.primary"> шт.</span>
                <span style="color: #292929bf">
                  шт.
                </span>
              </span>
            </p>
          </ng-container>
        </ul>

        <div class="list-inputs-wrapper" *ngIf="isListCounts">
          <bz-count-packaging [qty]="BzProduct?.packageNum" [type]="'parent'" [namePack]="'packaging'"
            (onDecrementCount)="decrementCountPackagesInList($event)"
            (onIncrementCount)="incrementCountPackagesInList($event)"></bz-count-packaging>

          <bz-count-packaging *ngIf="BzProduct?.packageContentNum > 1" [qty]="BzProduct?.blisterNum" [type]="'child'"
            [namePack]="BzProduct?.packageContentType" (onDecrementCount)="decrementCountBlistersInList($event)"
            (onIncrementCount)="incrementCountBlistersInList($event)"></bz-count-packaging>

        </div>

        <div class="list-inputs-wrapper" *ngIf="isCart">

          <ng-container *ngIf="showPopUpQty">
            <span (click)="close()" class="popup-max-qty">
              <span *ngIf="BzProduct?.balanceNum % 1 == 0">{{'remainderOfQty' | transloco}}
                {{ BzProduct.balanceNum | declension }}</span>
              <span *ngIf="BzProduct?.balanceNum % 1 !== 0">{{'remainderOfQty' | transloco}}
                {{ BzProduct.balanceNum | mathfloor | declension }}
                {{'and' | transloco}}
                {{ (( (BzProduct.balanceNum % 1) * BzProduct.packageContentNum) | number: '1.0-0') }}
                {{ ((BzProduct.packageContentType | lowercase) | declensionString: (( (BzProduct.balanceNum % 1) *
                BzProduct.packageContentNum) | number: '1.0-0') ) }}
              </span>
              <span class="triangle"></span>
            </span>
          </ng-container>

          <bz-count-packaging [qty]="BzProduct?.packageNum" [type]="'parent'" [namePack]="'packaging'" [isCart]="true"
            (onDecrementCount)="decrementCountPackagesInCart($event)"
            (onIncrementCount)="incrementCountPackagesInCart($event);"></bz-count-packaging>

          <bz-count-packaging *ngIf="BzProduct?.packageContentNum > 1" [qty]="BzProduct?.blisterNum" [type]="'child'"
            [namePack]="BzProduct?.packageContentType" [isCart]="true"
            (onDecrementCount)="decrementCountBlistersInCart($event)"
            (onIncrementCount)="incrementCountBlistersInCart($event);"></bz-count-packaging>

        </div>

      </div>

    </div>

    <div *ngIf="reviewsORcounts === _typeProduct.reviews" class="bz-product-footer">

      <ng-container *ngIf="reviewsORcounts === _typeProduct.reviews">
        <div class="bz-product-footer-left">
          <ngx-skeleton-loader [theme]="{ height: '14px',width: '120px',
                                'margin-bottom': '-8px'}"></ngx-skeleton-loader>
        </div>
        <div class="bz-product-footer-right">
          <ngx-skeleton-loader class="list" appearance="circle" [theme]="{
                                height: '45px',
                                width: '45px',
                                'margin-bottom': '-2px',
                                'margin-right': '15px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader class="favorite" appearance="circle" [theme]="{ height: '45px',width: '45px',
                                'margin-bottom': '3px',
                                'margin-right': '15px'}"></ngx-skeleton-loader>
        </div>
      </ng-container>

    </div>


    <div *ngIf="isCart" [ngClass]="{'btnDelPosition': isCart}" class="btnDelOrder" (click)="deleteProductFromCart()"
      innerHTML="{{'deleteProduct' | transloco}}"></div>

    <div *ngIf="isList" class="btnDelOrder" (click)="deleteProductFromList()">
      <p class="deleteIconTextMobile">{{'delete' | transloco}}</p>
    </div>

    <ng-container *ngIf="isBtnToMenu">
      <div id="btnDDM" (click)="openMenuPreparat(BzProduct, BzProduct?.menu)" class="bz-product-btn-to-menu" [ngStyle]="{
                    'mask': 'url(../../../assets/more.svg) no-repeat center',
                    '-webkit-mask': 'url(../../../assets/more.svg) no-repeat center',
                    '-webkit-mask-size': 'contain',
                    'mask-size': 'contain'
                }"></div>
    </ng-container>

    <ng-template #dropdownMenu></ng-template>

  </div>

</ng-template>
